<template>
    <v-overlay 
        :value="showLoading" 
        :z-index="9998"
        color="rgba(0, 0, 0, 0.6)"
        opacity="0.8"
    >
        <div class="loading-container">
            <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                width="4"
            ></v-progress-circular>
            <div v-if="message" class="loading-message mt-4">
                {{ message }}
            </div>
        </div>
    </v-overlay>
</template>

<style scoped>
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.loading-message {
    color: white;
    font-size: 16px;
    font-weight: 500;
    max-width: 300px;
    word-wrap: break-word;
}
</style>

<script>
export default {
    name: "VLoading",
    data() {
        return {
            showLoading: false,
            message: '',
            requestCount: 0
        }
    },
    computed: {
        isVisible() {
            return this.showLoading;
        }
    },
    methods: {
        show(message = 'Carregando...') {
            this.message = message;
            this.requestCount++;
            this.showLoading = true;
        },
        hide() {
            this.requestCount = Math.max(0, this.requestCount - 1);
            if (this.requestCount === 0) {
                this.showLoading = false;
                this.message = '';
            }
        },
        forceHide() {
            this.requestCount = 0;
            this.showLoading = false;
            this.message = '';
        },
        reset() {
            this.forceHide();
        }
    }
}
</script>